/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cart-widget[_ngcontent-%COMP%]{display:inline-block;padding:3px}\n/*# sourceMappingURL=cart-widget.component.css.map*/"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/admin/cart-widget/cart-widget.component.css.shim.ngstyle.js.pre-build-optimizer.js